import React, {Component} from "react";
import Api from "../../api/Api";
import './Admin.css';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {history} from "../../routes/Routing";
import Authentication from "../../authentication/Authentication";
import Footer from "../footer/Footer";
import RunningInstances from "./RunningInstances";
import StoppedInstances from "./StoppedInstances";
import ScheduledJobs from "./ScheduledJobs";
import Nav from "../../nav/Nav"
import PisaasSignUpPopUp from "../instances/PisaasSignUpPopUp";
import InstancesButtons from "../instances/InstancesButtons";
import Search from "../search/Search"

const api = new Api();

export default class Admin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            pisaasInstances: [],
            requestingPisaasInstances: false,
            showPisaasSignUp: false,
            selectedTab: "runningInstances",
            scheduledJobs: [],
            requestingScheduledJobs: false,
            searchTerm: "",
            displayAsList: false,
            exceededLoadBalancer: false
        };

        this.authentication = new Authentication();
    };


    componentDidMount() {
        this.load();
        this.pisaasInstanceInterval = setInterval(this.pisaasInstancesRefresh, 10000);
    }

    componentWillUnmount() {
        if (this.pisaasInstanceInterval) {
            clearInterval(this.pisaasInstanceInterval);
        }
    };

    load = () => {
        this.setState({
            loading: true,
            requestingPisaasInstances: true,
            requestingScheduledJobs: true
        });

        if (this.authentication.isAdmin()) {
            api.fetchPisaasInstances(this.setPisaasInstances, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });
        }

        if (this.authentication.isAdmin()) {
            api.pisaasFetchScheduledJobs(this.setScheduledJobs, function (err) {
                console.log(err);
                toast.error("Failed to fetch schedeled jobs", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });
        }
        if (this.authentication.isAdmin()) {
            api.pisaasExceededLoadBalancer(this.setExceededLoadBalancer, function (err) {
                console.log(err);
                toast.error("Failed to load balancer rules", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });
        }
    };

    setExceededLoadBalancer = async (exceededLoadBalancer) => {
        this.setState(
            {
                exceededLoadBalancer: exceededLoadBalancer.message
            });
        if (exceededLoadBalancer.message === false) {
            toast.warn("Unable to create PiSaaS instance at this time, please contact support@panintelligence.com", {
                position: toast.POSITION.BOTTOM_RIGHT
            })
        }
        ;
    };

    setScheduledJobs = async (scheduledJobs) => {
        this.setState(
            {
                scheduledJobs: scheduledJobs,
                requestingScheduledJobs: false,
                loading: false
            });
    };

    scheduledJobRefresh = () => {
        setTimeout(function (successCallback) {
            api.pisaasFetchScheduledJobs(successCallback, function (err) {
                console.log(err);
                toast.error("Failed to refresh running instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });
        }, 1000, this.setPisaasInstancesMaintainRequesting);
    };

    pisaasInstancesRefresh = () => {
        setTimeout(function (successCallback) {
            api.fetchPisaasInstances(successCallback, function (err) {
                console.log(err);
                toast.error("Failed to refresh running instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });
        }, 1000, this.setPisaasInstancesMaintainRequesting);
    };

    setPisaasInstances = async (pisaasInstances) => {
        if (!this.authentication.isAdmin()) {
            return;
        }

        this.setState(
            {
                pisaasInstances: pisaasInstances,
                requestingPisaasInstances: false,
                loading: false
            });
    };

    setPisaasInstancesMaintainRequesting = async (pisaasInstances) => {
        if (!this.authentication.isAdmin()) {
            return;
        }

        this.setState(
            {
                pisaasInstances: pisaasInstances,
                requestingPisaasInstances: false,
                loading: false
            });
    };

    logout = () => {
        this.authentication.logout(function () {
            history.push('/');
        });
    };

    togglePisaasCreatePopUp = () => {
        this.setState({
            showPisaasSignUp: !this.state.showPisaasSignUp
        });
    };

    loadAfterCreate = () => {
        this.setState(
            {
                requestingPisaasInstances: true,
                loading: true
            });

        api.fetchPisaasInstances(this.setPisaasInstances, function (err) {
            console.log(err);
            toast.error("Failed to load your instances", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    };

    updateSelectedTab = (e) => {
        this.setState({
            selectedTab: e.target.value
        })
    }

    setSearchTerm = (searchTerm) => {
        this.setState({
            searchTerm: searchTerm
        })
    }

    toggleViewAsList = () => {
        this.setState({
            displayAsList: !this.state.displayAsList
        })

    }

    render() {
        const stoppedInstancePacakgeId = 5
        const terminatedInstancePacakgeId = 9
        return (
            <div className={"instances-container"} data-testid="admin.instances.container">
                <Nav history={this.props.history}/>
                <div className={"instances-header gap-bottom-5"}>
                    <h1 className={"instances-heading"} data-testid="admin.instances.heading">Admin Panel</h1>
                    <InstancesButtons loading={this.state.loading} logout={this.logout} load={this.load}
                                      requestingTryPi={this.state.requestingPisaasCustomerInstances}
                                      allowCreation={this.state.exceededLoadBalancer}
                                      createTryPiInstance={this.createTryPiInstance}
                                      toggleSignUp={this.togglePisaasCreatePopUp}
                    />
                </div>
                <div className={"admin-info"} data-testid="admin.info">
                    <ul>
                        <li>Any instances created will take around 10 minutes to start up</li>
                        <li>Until the containers start up the instance will show under stopped instances</li>
                    </ul>
                </div>
                <select onChange={(e) => this.updateSelectedTab(e)} className={"dropdown pi-input"} name={"tab"}
                        id={"tab"} data-testid="admin.instances.dropdown">
                    <option className={"option-value"} value={"runningInstances"}>Running Instances</option>
                    <option className={"option-value"} value={"stoppedInstances"}>Stopped Instances</option>
                    <option className={"option-value"} value={"scheduledJobs"}>Scheduled Jobs</option>
                </select>
                <div className={"search-bar-and-view-panel"}>
                    <Search searchTerm={this.state.searchTerm} setSearchTerm={this.setSearchTerm}/>
                    <div>
                        <i onClick={() => this.toggleViewAsList()}
                           className={this.state.displayAsList ? "fa fa-list list-view-icon-active" : "fa fa-list list-view-icon"}
                           data-testid="toggle.list.view"
                           aria-hidden="true"/>
                    </div>
                </div>
                {this.authentication.isAdmin() && this.state.selectedTab === "runningInstances" ?
                    <RunningInstances isList={this.state.displayAsList} searchTerm={this.state.searchTerm}
                                      isAdmin={true}
                                      runningInstances={this.state.pisaasInstances.filter((instance => instance.package_id !== stoppedInstancePacakgeId && instance.package_id !== terminatedInstancePacakgeId))}
                                      requestingPisaasInstances={this.state.requestingPisaasInstances}
                                      refreshPisaasInstances={this.pisaasInstancesRefresh}/> : <></>}
                {this.authentication.isAdmin() && this.state.selectedTab === "stoppedInstances" ?
                    <StoppedInstances isList={this.state.displayAsList} searchTerm={this.state.searchTerm}
                                      isAdmin={true}
                                      stoppedInstances={this.state.pisaasInstances.filter((instance => instance.package_id === stoppedInstancePacakgeId && !instance.trypi_url))}
                                      requestingPisaasInstances={this.state.requestingPisaasInstances}
                                      refreshPisaasInstances={this.pisaasInstancesRefresh}/> : <></>}
                {this.authentication.isAdmin() && this.state.selectedTab === "scheduledJobs" ?
                    <ScheduledJobs isList={this.state.displayAsList} searchTerm={this.state.searchTerm}
                                   adminRefresh={this.load} pisaasInstances={this.state.pisaasInstances} isAdmin={true}
                                   scheduledJobs={this.state.scheduledJobs}
                                   requestingScheduledJobs={this.state.requestingScheduledJobs}
                                   scheduledJobRefresh={this.scheduledJobRefresh}/> : <></>}

                {this.state.showPisaasSignUp ? <PisaasSignUpPopUp togglePopUp={this.togglePisaasCreatePopUp}
                                                                  refreshPisaasInstances={this.pisaasInstancesRefresh}/> : <></>}
                <Footer/>
            </div>
        );
    }
}
